import _ from 'lodash'
import template from './numeric-filter.hbs'
import DatasetsNumericFilter from 'scoreboard/datasets/filters/datasets-numeric-filter'
import HasOperatorsFilter from 'scoreboard/reports/common/filter/has-operators-filter'
import moveDecimal from 'scoreboard/components/move-decimal'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import { formatNumericValue } from 'scoreboard/reports/common/filter/pretty-range-numeric'
import isPercentDisplayed from 'scoreboard/components/is-percent-displayed'
import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER } = DataType

var NumericFilter = HasOperatorsFilter.extend({

	className: 'report-filters filter numeric-filter',

	initialize: function(options = {}) {
		this.options = options
		options.dataType = this._dataType()
		HasOperatorsFilter.prototype.initialize.apply(this, arguments)
		this._textMarkedFields = []
		this.on('operator', () => {
			_.invokeMap([this._valuesMarkedField].concat(this._textMarkedFields), 'clearError')
		})
	},

	/**
	 * @override
	 *
	 * Passed to render-values-select to help with converting backing, model
	 * values to displayable labels
	 **/
	_formatValue(val) {
		return formatNumericValue(val, this._dataType())
	},

	_dataType() {
		return this.options.dataType || (
			this.options.isScorecardScore ? 'score' : NUMBER
		)
	},

	/**
	 * @override
	 *
	 * Passed to render-values-select to help with converting newly-entered
	 * values to their correct model representation
	 **/
	_convertValue(value) {
		// #49493 only move decimal if needed (dataType is percent, or dataType
		// is 'score' and scores are displayed as %)
		if (isPercentDisplayed(this._dataType())) {
			// if the input is a string, strip percent sign if present
			let val = this.stripPercentSignFromStringIfNeeded(value)
			// only try to moveDecimal if we have a numeric value
			if (val && !_.isNaN(_.toNumber(val))) {
				return moveDecimal(val, -2)
			}
		}

		return value
	},

	stripPercentSignFromStringIfNeeded: function(value) {
		if (value && typeof value === 'string') {
			return value.replace(/%$/, '')
		}
		return value
	},

	_renderAdditionalControls: function () {
		this.$el.append(template())
		this._datasetsNumericFilter = new DatasetsNumericFilter(_.defaults({
			floating: true,
			el: this.el,
			filter: {
				value1: this.data.value1,
				value2: this.data.value2,
				aggregationType: 'none'	//currently unused but specified to avoid a blowup when saving state
			}
		}, this.options))
		this._datasetsNumericFilter.render()
		this._textMarkedFields = _.map(this._datasetsNumericFilter.valueOrEquations, v => v.markedField)

		//not using update type for now
		this.$('.update-type').addClass('is-not-displayed')

		return this
	},

	test: function() {
		if (this._isHidingValues()) {
			if (this._operatorSelect().val() == 'between-number') {
				return _.find(_.invokeMap(this._textMarkedFields, 'test'), val => !_.isNil(val))
			} else {
				return null
			}
		}
		return HasOperatorsFilter.prototype.test.apply(this, arguments)
	},

	gather: function(e) {
		if (this._isHidingValues()) {
			this._datasetsNumericFilter.saveState()
			let {value1, value2} = this._datasetsNumericFilter.options.filter
			this.data.value1 = value1
			this.data.value2 = value2
			this.data.values = []
		}
		const transformer = this._getDisplayToBackingValueTransformer()
		this.data = _.extend(this.data, {
			values: this.data.values.map(transformer)
		})

		return this.data
	},

	_getDisplayToBackingValueTransformer: function() {
		switch (this.options.dataType) {
			case 'number': return _.identity
			case 'percent': return _.identity
			case 'score': return _.identity
			case 'currency': return numericEvaluator
		}
	},

	remove: function() {
		HasOperatorsFilter.prototype.remove.apply(this, arguments)
		this._datasetsNumericFilter.remove()
	}

})

export default NumericFilter

NumericFilter.__filename__ = 'reports/common/filter/numeric-filter.js'
